import React from "react";
import { ClockIcon, BoltIcon, ExclamationTriangleIcon, PauseIcon } from "@heroicons/react/24/solid";
import { encodeFirestoreId } from "../../services/firestore/firebaseService";

const statusStyles = {
  ACTIVE: {
    label: "ACTIVE",
    color: "bg-green-600",
    icon: <BoltIcon className="w-4 h-4 mr-1" />,
  },
  UPCOMING: {
    label: "UPCOMING",
    color: "bg-blue-600",
    icon: <ClockIcon className="w-4 h-4 mr-1" />,
  },
  PAUSED: {
    label: "PAUSED",
    color: "bg-yellow-500",
    icon: <PauseIcon className="w-4 h-4 mr-1" />,
  },
  EXPIRED: {
    label: "EXPIRED",
    color: "bg-red-600",
    icon: <ExclamationTriangleIcon className="w-4 h-4 mr-1" />,
  },
  "EXPIRING SOON": {
    label: "EXPIRING SOON",
    color: "bg-orange-600",
    icon: <ExclamationTriangleIcon className="w-4 h-4 mr-1" />,
  },
};

const MembershipCard = ({ membership, onClick }) => {
  console.log(membership)
  const status = statusStyles[membership.status] || statusStyles.ACTIVE;
  const backgroundImage = membership.subSGloopData?.clubImage || "https://via.placeholder.com/400x200";

  return (
    <div
      onClick={onClick}
      className="relative rounded-2xl overflow-hidden shadow-lg cursor-pointer group transition-transform hover:scale-[1.02]"
    >
      {/* Background Image */}
      <img
        src={backgroundImage}
        alt={membership.subSGloopData?.subGroupName || "Membership"}
        className="w-full h-56 object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50 flex flex-col justify-between p-4 text-white">
        {/* Status badge */}
        <div className="flex justify-between items-start">
          <div
            className={`flex items-center text-xs font-semibold px-2 py-1 rounded-md ${status.color}`}
          >
            {status.icon}
            {status.label}
          </div>
          {/* Days info */}
          {/* <div className="text-right">
            <p className="text-[10px] uppercase text-gray-300">
              {membership.status === "UPCOMING"
                ? "Starts In"
                : membership.status === "ACTIVE"
                ? "Ends In"
                : membership.status === "PAUSED"
                ? "Resumes In"
                : "Ended"}
            </p>
            <p
              className={`text-3xl font-bold ${
                membership.status === "EXPIRED"
                  ? "text-red-400"
                  : "text-white"
              }`}
            >
              {membership.daysLeft || "00"}
            </p>
            <p className="text-[10px] uppercase tracking-wider text-gray-300">
              Days
            </p>
          </div> */}
        </div>

        {/* Bottom section */}
        <div>
          <h3 className="text-lg font-bold">
            {membership.subSGloopData?.subGroupName || "Membership Name"}
          </h3>
          {/* <p className="text-sm text-gray-200">
            {membership.duration || "3 months"} •{" "}
            {membership.dateText || "ends soon"}
          </p> */}
          <p className="text-sm text-gray-200">
            ID: {encodeFirestoreId(membership.id) || ""}
          </p>
          <p className="text-sm font-semibold text-blue-400 mt-1">
            {membership.ctaText || "VIEW DETAILS"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MembershipCard;
